import { ReactNode } from 'react';

import { useSnackbar as useNotistackSnackbar } from 'notistack';

import { AlertProps, SnackbarProps } from '@mui/material';

interface SnackbarOptions extends SnackbarProps {
  severity?: AlertProps['severity'];
  action?: ReactNode;
  persist?: boolean;
}

const DEFAULT_AUTO_HIDE_DURATION = 3000;

export const useSnackbar = () => {
  const { enqueueSnackbar } = useNotistackSnackbar();

  return ({
    severity,
    message,
    autoHideDuration,
    action,
    persist,
    anchorOrigin,
    ...props
  }: SnackbarOptions) =>
    enqueueSnackbar({
      variant: severity ?? 'success',
      message,
      autoHideDuration: autoHideDuration ?? DEFAULT_AUTO_HIDE_DURATION,
      action,
      persist,
      anchorOrigin,
      SnackbarProps: props,
    });
};
